import React from 'react';
import { Button, Row, Col } from 'reactstrap';

import {
  Form, TextField, Intl, Checkbox, Auth, LinkLegal,
} from 'components';
import {
  composeValidators, email, equalTo, required,
} from 'config/InputErrors';

export default React.memo( ( { dataSubmitted, onSubmit, data, price } ) => (
  dataSubmitted
    ? (
      <Auth title="registerActivationTitle">
        <Row className="mt-3">
          <Col md={6} className="m-auto text-center">
            <i className="far fa-check-circle fa-4x text-gray-7 mb-3" />
            <p className="text-gray-7 m-0">
              <Intl id="registerNewAccountEmailSent" />
            </p>
            <p className="text-gray-7">
              <Intl id="registerNewAccountEmailNotSpam" />
            </p>
          </Col>
        </Row>
      </Auth>
    ) : (
      <Auth title="registerTitle" values={{ currency: data && data.symbol, price: price && price.fee }}>
        <h1 className="text-gray-1 font-weight-light subtitle text-center">
          <Intl id="registerSubtitle" />
        </h1>

        <Row className="mt-4">
          <Col md={10} className="m-auto">
            <Form
              onSubmit={onSubmit}
              showErrorsInHeader
            >
              <>
                <Row>
                  <Col md={12}>
                    <TextField
                      field="name"
                      label="accountName"
                      validate={required}
                      labelClass="required"
                      labelOnFocus="registerAccountNameLabel"
                      placeholder="accountName"
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <TextField
                      field="firstName"
                      label="firstName"
                      validate={required}
                      labelClass="required"
                      placeholder="firstNamePlaceholder"
                    />
                  </Col>
                  <Col md={6}>
                    <TextField
                      field="lastName"
                      label="lastName"
                      validate={required}
                      labelClass="required"
                      placeholder="lastNamePlaceholder"
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <TextField
                      field="email"
                      validate={composeValidators( required, email )}
                      label="email"
                      labelClass="required"
                      placeholder="emailPlaceholder"
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <TextField
                      field="plainPassword"
                      label="password"
                      validate={required}
                      type="password"
                      labelClass="required"
                      placeholder="passwordPlaceholder"
                    />
                  </Col>
                  <Col md={6}>
                    <TextField
                      field="passwordConfirmation"
                      label="passwordConfirmation"
                      validate={composeValidators( required, equalTo( 'plainPassword' ) )}
                      validateTranslateValues={{ label: 'password' }}
                      type="password"
                      labelClass="required"
                      placeholder="passwordPlaceholder"
                    />
                  </Col>
                </Row>

                <Row>
                  <Col md={6}>
                    <TextField
                      field="code"
                      label="promotionalCode"
                      placeholder="promotionalCode"
                    />
                  </Col>
                </Row>

                <Row className="mt-3">
                  <Col>
                    <Checkbox
                      field="termsConditions"
                      translateLabel={false}
                      validate={required}
                      label={(
                        <span className="mt-1 text-gray-1">
                          <Intl id="acceptTerms&Conditions" />
                          {' '}
                          <LinkLegal
                            label="terms&Conditions"
                            target="_blank"
                            rel="noopener noreferrer"
                            href={{
                              es: '//massphoning.es/terminos-y-condiciones/',
                              en: '//massphoning.com/terms-and-conditions/',
                            }}
                          />
                        </span>
                      )}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Checkbox
                      field="privacyPolicy"
                      translateLabel={false}
                      validate={required}
                      label={(
                        <span className="mt-1 text-gray-1">
                          <Intl id="acceptPrivacyPolicy" />
                          {' '}
                          <LinkLegal
                            label="privacyPolicy"
                            target="_blank"
                            rel="noopener noreferrer"
                            href={{
                              es: '//massphoning.es/politica-de-privacidad/',
                              en: '//massphoning.com/privacy-policy/',
                            }}
                          />
                        </span>
                      )}
                    />
                  </Col>
                </Row>
              </>

              <div className="text-center mt-4">
                <Button color="app-default" size="app-sm" className="text-lg lh-130">
                  <Intl id="startNowBtn" />
                </Button>
              </div>
            </Form>
          </Col>
        </Row>

        {/* <Col md={dataSubmitted ? 4 : 8} className="m-auto">
      <Card className="card-app-default mx-3">
        <CardBody>
          {dataSubmitted
            ? (
              <div className="text-center">
                <i className="far fa-check-circle fa-4x text-gray-7 mb-3" />
                <p className="text-gray-7 m-0">
                  <Intl id="registerNewAccountDataSent" />
                </p>
                <p className="text-gray-7">
                  <Intl id="registerNewAccountEmailSent" />
                </p>

                <Link
                  to="/auth/login"
                  className="btn-link"
                >
                  <Intl id="backLogin" />
                </Link>
              </div>
            )
            : (
              numeral
            )}
        </CardBody>
      </Card>
    </Col> */}
      </Auth>
    )
) );
